import React from 'react';
import { useDownloadCSVMutation } from 'reducers/marketplace.service';
import { IconButton } from '@chakra-ui/react';
import { DownloadIcon } from '@chakra-ui/icons';
import { LENDER_TYPE } from 'constants/index';
import moment from 'moment';
import { useLocation } from 'react-router-dom';
// const csvToJson = (csv) => {
//     const lines = csv.split('\n'); // Split CSV into rows
//     const headers = lines[0].split(','); // Extract headers

//     const result = [];

//     // Loop through each row and create JSON objects
//     for (let i = 1; i < lines.length; i++) {
//         const currentLine = lines[i].split(',');

//         if (currentLine.length === headers.length) {
//             const rowObject = {};
//             headers.forEach((header, index) => {
//                 rowObject[header.trim()] = currentLine[index].trim();
//             });
//             result.push(rowObject);
//         }
//     }

//     return result;
// };

export default function DownloadCsv({ UserType, search = '' , companyId = null }) {
    const [downloadFile] = useDownloadCSVMutation();
    const location = useLocation();

    const handleDownload = () => {
        let querystr = null;
        if (UserType === LENDER_TYPE) {
            querystr = `resourceType=${UserType}&companyId=${companyId}&`;
        } else {
            querystr = `resourceType=${UserType}&`;
        }
        downloadFile({ querystr: querystr + location.search.replace(/^\?/, '') }).unwrap().catch(async (res) => {
            const blob = new Blob([res.data], { type: 'text/csv' });
            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            // let date = new Date();
            // let day = date.getDate();
            // let month = date.getMonth() + 1;
            // let year = date.getFullYear();
            // // dis arrangement can be altered based on how we want the date's format to appear.
            // let currentDate = `${day}-${month}-${year}`;
            let currentDate = moment().format('MM-DD-YYYY-H-mm');
            a.download = `${UserType.toLowerCase() + '-' + currentDate}.csv`; // Define the downloaded file name
            document.body.appendChild(a);
            a.click();
            a.remove();
        });
    };
    return (
        <IconButton onClick={handleDownload} fontSize={'large'} color={'primary'} >
            <DownloadIcon/>
        </IconButton>
    );
}
